/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import { useModal, useTranslation } from 'Shared/util/custom-hooks';
import PropTypes from 'prop-types';
import useTranslationContext from 'Contexts/translation-context';
import InlineSvg from 'Shared/components/inline-svg';
import { exportFile, saveFormat } from 'Shared/util/export-helper';
import ConfirmationModal from 'Shared/components/modals/confirmation-modal';
import Spinner from 'Shared/components/spinner';
import styles from './export-options.css';


const ExportOptions = ({
  exportPage,
  filterArgs,
  dispatchStatusMessage,
  rows,
}) => {
  const [loading, setLoading] = useState(false);
  const [cacheKey, setCacheKey] = useState(null);
  const [selectedFormat, setSelectedFormat] = useState(undefined);
  const { isModalOpen, openModal, closeModal } = useModal();
  const t = useTranslation(x => x.export);
  const ti = useTranslation(x => x.invoices);
  const { translationData } = useTranslationContext();

  const getExportHandler = (clear = false) => ({
    dispatchStatusMessage,
    cacheKey: {
      get: () => (clear ? null : cacheKey),
      set: setCacheKey,
    },
    setLoading,
  });

  const isExportDisabled = () => (rows === undefined || rows.length === 0) && (filterArgs === null || filterArgs.items.length < 1);

  return (
    <>
      <div className={styles.exportOptions}>
        {loading ? <Spinner /> : (
          <>
            <a
              disabled={isExportDisabled()}
              onClick={() => {
                if (!isExportDisabled()) {
                  setSelectedFormat(saveFormat.XLSX);
                  exportFile(exportPage, filterArgs, saveFormat.XLSX, getExportHandler(true), openModal, ti, translationData.languageCode);
                }
              }}
            >
              <InlineSvg src="/download.svg" />xlsx
            </a>
            <a
              disabled={isExportDisabled()}
              onClick={() => {
                if (!isExportDisabled()) {
                  setSelectedFormat(saveFormat.CSV);
                  exportFile(exportPage, filterArgs, saveFormat.CSV, getExportHandler(true), openModal, ti, translationData.languageCode);
                }
              }}
            >
              <InlineSvg src="/download.svg" />csv
            </a>
          </>
        )}
      </div>

      <ConfirmationModal
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        contentText={t.filesSizeExceeds}
        confirmText={t.continue}
        onConfirm={() => exportFile(exportPage, filterArgs, selectedFormat, getExportHandler(), null, ti, translationData.languageCode)}
      />
    </>
  );
};

ExportOptions.propTypes = {
  exportPage: PropTypes.string,
  filterArgs: PropTypes.object,
  dispatchStatusMessage: PropTypes.func,
  rows: PropTypes.array,
};

export default ExportOptions;
